import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

const PRESETS = [
  { rows: 1, cols: 1, label: '1×1' },
  { rows: 1, cols: 2, label: '1×2' },
  { rows: 2, cols: 1, label: '2×1' },
  { rows: 2, cols: 2, label: '2×2' },
  { rows: 1, cols: 3, label: '1×3' },
  { rows: 2, cols: 3, label: '2×3' },
  { rows: 3, cols: 3, label: '3×3' },
];

interface LayoutPickerProps {
  screenLabel: string;
  rows: number;
  cols: number;
  onChange: (screenLabel: string, rows: number, cols: number) => void;
}

export function LayoutPicker({ screenLabel, rows, cols, onChange }: LayoutPickerProps) {
  const current = `${rows}x${cols}`;

  const handleChange = (_: unknown, value: string | null) => {
    if (!value) return;
    const preset = PRESETS.find((p) => `${p.rows}x${p.cols}` === value);
    if (preset) {
      onChange(screenLabel, preset.rows, preset.cols);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary' }}>
        Default Layout
      </Typography>
      <ToggleButtonGroup
        value={current}
        exclusive
        onChange={handleChange}
        size="small"
      >
        {PRESETS.map((p) => {
          const key = `${p.rows}x${p.cols}`;
          return (
            <ToggleButton key={key} value={key} sx={{ fontSize: 12, px: 1.5 }}>
              {p.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Box>
  );
}
